
const mutations = {
    purchase_add(state, payload) {
        state.purchase_list = payload.purchase_list;
        state.date = payload.date;
        state.total_grand = payload.total_grand;
    },
    login_success(state, payload) {
        state.access_token = payload.access_token;
        state.userDetail = payload.userDetail;
        state.status = payload.status;
    },
    logout_success(state) {
        state.access_token = null;
        state.userDetail = null;
        state.status = null;
    },
    temp_lots(state, payload) {
        state.lot_number = payload.lot_number
    },
    temp_clear(state) {
        state.lot_number = null
    },
    temp_lots_product(state, payload) {
        state.lot_number_product_id = payload.lot_number_product_id
        state.lot_number_product_date = payload.lot_number_product_date
    },
    temp_lots_product_clear(state) {
        state.lot_number_product_id = null
        state.lot_number_product_date = null
    },
    temp_data(state, payload) {
        state.loop_id = payload.loop_id;
        state.data_frozen = payload.data_frozen;
    },
    temp_header_list(state, payload) {
        state.po_lists_id = payload.po_lists_id;
        state.supplier_id = payload.supplier_id;
        state.supplier_name = payload.supplier_name;
        state.type_vat = payload.type_vat;
    },
    temp_data_clear(state) {
        state.data_frozen = []
        state.po_lists_id = null
        state.supplier_id = null
        state.supplier_name = null
        state.type_vat = null
        state.loop_id = 0
    },
    link_temp(state, payload) {
        state.link_url = payload.link_url;
    },
    product_list_temp(state, payload) {
        state.page = payload.page;
    },
    product_nonSet_temp(state, payload) {
        state.page_nonSet = payload.page_nonSet;
    },
    product_close_temp(state, payload) {
        state.page_close = payload.page_close;
    },
    product_low_cost_temp(state, payload) {
        state.page_low_cost = payload.page_low_cost;
    },
    product_high_cost_temp(state, payload) {
        state.page_high_cost = payload.page_high_cost;
    },
    product_per_page_temp(state, payload) {
        state.perPage = payload.perPage;
    },
    getInvoice(state, data) {
        state.invoiceDetail = data;
    },
    clearInvoice(state) {
        state.invoiceDetail = {};
    },
    getSocket(state, data) {
        state.socket_list = data;
    },
    clearSocket(state) {
        state.socket_list = null;
    },
    clearMonitor(state) {
        state.monitor_code = null;
    },
    tabs(state, data) {
        state.tabs = data;
    },
}
export default mutations
